 const model = [
  //  {
  //    name: "watch",
  //    models: [
  //      "/Assets/blue_watch.glb",
  //      "Assets/pink_watch.glb",
  //      "Assets/golden_watch.glb",
  //    ],
  //  },
  //  {
  //   name: "neckband",
  //   models: [
  //     "/Assets/neckband.glb",
  //   ],
  // },
  //  
  //  
  //  
  //  
  //  
  //  
  //  
  //  
  //  
  //  
  //  
  //  
  //  
  //  
  //  
  //  
  {
    name: "black_earbuds",
    models: [
      "Assets/earbud40_close.glb",
      "Assets/earbuds40_open_with_earpodsout.glb",
      "Assets/earbud40_open.glb",
    ],
    poster:"Assets/LoadingImage/black_earbuds.png"
  },
  {
    name: "gaming",
    models: [
      "Assets/close_new.glb",
      "Assets/openlid_earpodinside_new.glb",
      "Assets/openlid_new.glb",
    ],
    poster:"Assets/LoadingImage/gaming_earbuds.png"
  },
    {
      name: "blue_earbuds",
     models: [
        "Assets/earbud70_close.glb",
        "Assets/earbud70_open_with_earpods_out.glb",
        "Assets/earbud70_open.glb",
      ],
      poster:"Assets/LoadingImage/blue_earbuds.png"
  },
   {
    name:"gaming_new",
    models:[
      "Assets/close_new.glb",
      "Assets/openlid_earpodinside_new.glb",
      "Assets/openlid_new.glb",
    ],
    poster:"Assets/LoadingImage/gaming_earbuds.png"
   },
   {
    name:"Head-Phone",
    models:[
      "Assets/new/headphone1_v01.glb"
    ],
    poster:"Assets/LoadingImage/gaming_headphone.png"
   },
  //  {
  //   name:"Watch",
  //   models:[
  //     "Assets/watch.glb"
  //   ],
  //   poster:"Assets/LoadingImage/black_earbuds.png"
  //  },
   {
    name:"Neckband",
    models:[
      "Assets/new/neckband_v01.glb"
    ],
    poster:"Assets/LoadingImage/black_neckband.png"
   },
   {
    name:"New-Headphone",
    models:[
      "Assets/new/headphone02_new.glb"
    ],
    poster:"Assets/LoadingImage/black_headphone.png"
   },
  { name:"New-Watch",
   models:[
    "Assets/new/Watch.glb"
   ],
   poster:"Assets/LoadingImage/pink-watch.png"
  }

 ];
export default model
